import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1c56a28be93c00146e903f_1780405121817/lendo/src/app/partner/page.tsx");
